import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlaceholderErrorComponent } from './components/placeholder-error/placeholder-error.component';
import { LoaderCommonComponent } from './components/loader-common/loader-common.component';
import { PlaceholderNoDataComponent } from './components/placeholder-no-data/placeholder-no-data.component';
import { PlaceholderForbiddenComponent } from './components/placeholder-forbidden/placeholder-forbidden.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { TipoImpuestoPipe } from './pipes/tipo-impuesto.pipe';
import { TipoImpuestoTotalPipe } from './pipes/tipo-impuesto-total.pipe';
import { LoaderRbacComponent } from './components/loader-rbac/loader-rbac.component';


@NgModule({
  declarations: [
    PlaceholderErrorComponent,
    LoaderCommonComponent,
    PlaceholderNoDataComponent,
    PlaceholderForbiddenComponent,
    SidebarComponent,
    NavbarComponent,
    TipoImpuestoPipe,
    TipoImpuestoTotalPipe,
    LoaderRbacComponent
  ],
  imports: [
    CommonModule,
    NzAvatarModule,
    NgbCollapseModule,
    RouterModule,
    NzDropDownModule
  ],
  exports: [
    PlaceholderErrorComponent,
    LoaderCommonComponent,
    PlaceholderNoDataComponent,
    SidebarComponent,
    NavbarComponent,
    TipoImpuestoPipe,
    TipoImpuestoTotalPipe,
    LoaderRbacComponent
  ]
})
export class SharedModule { }
